import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { throwError } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { environment } from "../../environments/environment";

enum EndpointRoutes {
    UPDATE_PROFILE = "htlAccount/updateProfile",
    UPDATE_PROFILE_PASSWORD = "htlAccount/changePassword",
    AUTHORIZE_USER = "camo/authorize",
    CHANGE_PASSWORD = "pilot/changePassword",
}

@Injectable({
    providedIn: "root",
})
export class ProfileService {
    constructor(private _http: HttpClient) {}

    public updateProfileData(firstName: string, lastName: string) {
        return this._http.post<any>(environment.serverUrl + EndpointRoutes.UPDATE_PROFILE, { firstName, lastName }).pipe(
            map((responseData) => {
                return responseData;
            }),
            catchError((errorRes) => {
                return throwError(errorRes);
            }),
        );
    }

    public updateProfilePassword(oldPassword: string, newPassword: string) {
        return this._http.post<any>(environment.serverUrl + EndpointRoutes.UPDATE_PROFILE_PASSWORD, { oldPassword, newPassword }).pipe(
            map((responseData) => {
                return responseData;
            }),
            catchError((errorRes) => {
                return throwError(errorRes);
            }),
        );
    }

    public authorize(username: string, password: string) {
        return this._http.post<any>(environment.serverUrl + EndpointRoutes.AUTHORIZE_USER, { username, password }).pipe(
            map((responseData) => {
                return responseData;
            }),
            catchError((errorRes) => {
                return throwError(errorRes);
            }),
        );
    }

    public changePilotPassword(pilotId: string, oldPassword: string, newPassword: string) {
        return this._http
            .put<any>(environment.serverUrl + EndpointRoutes.CHANGE_PASSWORD, {
                id: pilotId,
                oldPassword: oldPassword,
                newPassword: newPassword,
            })
            .pipe(
                map((responseData) => {
                    return responseData;
                }),
                catchError((errorRes) => {
                    return throwError(errorRes);
                }),
            );
    }
}
